import React from 'react';
import { User, Calendar } from 'lucide-react';

/**
 * Секция личных данных формы пенсионного калькулятора
 */
const PersonalDataSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Дата рождения */}
      <div>
        <label htmlFor="birthDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Calendar className="w-4 h-4 mr-2 text-emerald-500" />
          Дата рождения
        </label>
        <input
          type="date"
          id="birthDate"
          name="birthDate"
          value={formData.birthDate}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.birthDate ? 'input-error' : ''}`}
        />
        {errors.birthDate && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.birthDate}
          </p>
        )}
      </div>

      {/* Пол */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <User className="w-4 h-4 mr-2 text-emerald-500" />
          Пол
        </label>
        <div className="flex space-x-4">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="gender"
              value="male"
              checked={formData.gender === 'male'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Мужской
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={formData.gender === 'female'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Женский
            </span>
          </label>
        </div>
        {errors.gender && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.gender}
          </p>
        )}
      </div>

      {/* Возраст выхода на пенсию */}
      <div>
        <label htmlFor="retirementAge" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Возраст выхода на пенсию
        </label>
        <input
          type="number"
          id="retirementAge"
          name="retirementAge"
          value={formData.retirementAge}
          onChange={handleInputChange}
          min="45"
          max="100"
          className={`form-input w-full ${errors.retirementAge ? 'input-error' : ''}`}
        />
        {errors.retirementAge && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.retirementAge}
          </p>
        )}
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          По закону: {formData.gender === 'male' ? '65 лет для мужчин' : '60 лет для женщин'}
        </p>
      </div>

      {/* Пустая ячейка для выравнивания сетки (или можно добавить другое поле) */}
      <div></div>
    </div>
  );
};

export default PersonalDataSection;